// Section ids used around the site map onto their own pages.
const routes = { home: '/', about: '/about', services: '/services', products: '/products', portfolio: '/portfolio', career: '/career', contact: '/contact' };

export function pathFor(id) {
  return routes[id] || '/';
}

export function goToSection(navigate, pathname, id) {
  const to = pathFor(id);
  if (to === pathname) window.scrollTo({ top: 0, behavior: 'smooth' });
  else navigate(to);
}
